import TextView from "../lib/TextView";

type SearchResult = {
  id?: string;
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  category?: string[];
};

type Props = {
  items?: SearchResult[];
  count?: number;
  from?: number;
  to?: number;
  isLoading?: boolean;
};

export default function SearchResults({
  items,
  count,
  from,
  to,
  isLoading,
}: Props) {
  return (
    <div className="search-results">
      <h2 className="text-h-large">Resultater</h2>
      <div>
        {isLoading
          ? "Søker..."
          : !count
            ? "Beklager, ingen resultater funnet"
            : `Viser ${from}-${to} av ${count}`}
      </div>
      <ul>
        {items.map(({ id, title, description, url, image }) => {
          const external = !!url?.match(/^https?:/);
          return (
            <li key={id}>
              <a
                href={url}
                target={external ? "_blank" : undefined}
                rel={external ? "noreferrer" : undefined}
              >
                <article>
                  {image && (
                    <figure>
                      <img src={image} alt="" />
                    </figure>
                  )}

                  <div>
                    <TextView component="h3" text={title} />
                    {!!description && <TextView text={description} />}
                  </div>
                </article>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
